// App.js
import React from 'react'
import { Routes, Route } from "react-router-dom"

import Home from "./components/Home"
import Shop from "./components/Shop"
import Login from "./components/Login"
import AddProduct from "./components/AddProduct"
import Singup from "./components/Signup"
import Orders from './components/Orders'
import Profile from './components/Profile'
import AllProductsProfile from './components/AllProductsProfile'
import HeroSection from './components/HeroSection'
// Remove old Chatbot import
// import Chatbot from './components/Chatbot'
import ProductDetail from './components/ProductDetail'
import AIDashboard from './components/AIDashboard'  // <-- NEW
import CreateShop from './components/CreateShop'
import Dashboard from './components/Dashboard'
import ForgotPassword from "./components/ForgotPassword"
import EditProduct from './components/EditProduct';
import PrivacyPolicy from './components/sub-footer/PrivacyPolicy'
import Disclaimer from './components/sub-footer/Disclaimer'
import TermsANDCondition from './components/sub-footer/TermsANDCondition'
import ProfileEdit from './components/ProfileEdit'

import Analytics from "./Analytics";
import Addadhero from './components/Addadhero'
import TopRatedProducts from './components/TopRatedProducts'
export default function App() {
  return (
    <div>
      <Analytics />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/:slug' element={<Shop />} />  
        <Route path='/:shopSlug/:productSlug' element={<ProductDetail />} />
        <Route path='/login' element={<Login />} />
        <Route path='/singup' element={<Singup />} />
        <Route path='/addproduct' element={<AddProduct />} />
        <Route path='/order' element={<Orders />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/allproducts' element={<AllProductsProfile />} />
        <Route path="/edit-product/:productslug" element={<EditProduct />} />
        <Route path='/addherosection' element={<HeroSection />} />
        <Route path='/ai-dashboard' element={<AIDashboard />} />
        
        <Route path="/create-shop" element={<CreateShop />} />
        <Route path='/dashboard' element={<Dashboard/>} />
        <Route path='/forgotpassword' element={<ForgotPassword/>}/>
        <Route path='/profileedit' element={<ProfileEdit/>} />

        //sub footer
        <Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
        <Route path='/disclaimer' element={<Disclaimer/>} />
        <Route path='/termsandconditions' element={<TermsANDCondition />} />


        //ads 
        <Route path='/createAd' element={<Addadhero/>} />

        //top products
        <Route path='/top-rated' element={<TopRatedProducts/>}/>
      </Routes>
    </div>
  )
}